import i18n from "i18next"
import { initReactI18next } from "react-i18next"
import _ from "lodash"

import Http from "i18next-http-backend"
import BackendAdapter from "i18next-multiload-backend-adapter"
import LanguageDetector from "i18next-browser-languagedetector"
import { MULTILANGUAGE_SUPPORT_ENABLED, BACKEND_URL, IS_DEV } from "./const"

declare const __COMMIT_HASH__: string

// Returns capitalized last key segment if no translation exists
const parseMissingKey = (key: string | undefined, capitalize?: boolean) => {
	if (key === undefined) return key
	const reg = /[^~]*$/
	const match = key.match(reg)
	let str = ""
	if (match) str = match[0]
	else str = key
	if (capitalize) str = str.charAt(0).toUpperCase() + str.slice(1)
	const noUnderlines = str.replace("_", " ")
	return noUnderlines
}

if (MULTILANGUAGE_SUPPORT_ENABLED) {
	i18n.use(LanguageDetector)
}

const hash = typeof __COMMIT_HASH__ !== "undefined" ? __COMMIT_HASH__ : "secret_hash_undefined"

i18n.use(BackendAdapter)
	// for all options read: https://www.i18next.com/overview/configuration-options
	.use(initReactI18next)
	.init({
		showSupportNotice: false,
		backend: {
			backend: Http,
			backendOption: {
				loadPath: `${BACKEND_URL}/locales/resources.json?lng={{lng}}&ns={{ns}}&hash=${hash}`,
				addPath: `${BACKEND_URL}/locales/add/{{lng}}/{{ns}}`,
				allowMultiLoading: true,
			},
		},
		react: {
			useSuspense: true,
		},
		// Sets default value as formatted last key segment automatically
		overloadTranslationOptionHandler: function (args) {
			const key = args[0]
			const opts = args[1]
			const result = parseMissingKey(key)
			return { ...(typeof opts === "object" && opts !== null ? opts : {}), defaultValue: result }
		},
		saveMissing: IS_DEV, // send not translated keys to endpoint
		supportedLngs: ["fi", "en", "sv"],
		fallbackLng: "fi",
		debug: IS_DEV, // Can be set to false if missing key console logs are too much
		keySeparator: "~",
		nsSeparator: "|",
		pluralSeparator: "§",
		interpolation: {
			escapeValue: false, // Allows rendering of special characters (/,",& etc.) instead of entity codes
		},
		missingInterpolationHandler: (_text, value, options) => {
			// Normalize interpolation variables to lowercase for case-insensitive matching of missing values
			const key = value[1]
			const lowerCaseKey = key?.toLowerCase()
			const lowerCaseOpts = _.mapKeys(options, (_v, k) => k.toLowerCase())
			const newValue = _.get(lowerCaseOpts, lowerCaseKey)
			if (newValue === undefined) {
				// Returns {{var}} text as fallback if no match exists
				const interpText = value[0]
				return interpText
			}
			return newValue
		},
		returnEmptyString: false,
	})

i18n.loadNamespaces(["values"], (err, t) => {
	if (err) console.log(err)
	return t
})

export default i18n
